// src/components/PageParallaxBackground.jsx
import React, { useEffect, useState } from "react";

export default function PageParallaxBackground() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY || 0);

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="page-parallax-bg"
      aria-hidden="true"
      style={{
        transform: `translateY(${scrollY * 0.09}px)`,
      }}
    >
      <img src="/background/blobnew1.svg" alt="" className="page-parallax-svg svg-1" />
      <img src="/background/blobnew2.svg" alt="" className="page-parallax-svg svg-2" />
      <img src="/background/blobnew3.svg" alt="" className="page-parallax-svg svg-3" />
      <img src="/background/blobnew4.svg" alt="" className="page-parallax-svg svg-4" />
    </div>
  );
}